import {Component, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {GenericActionComponent, GenericActionComponentsMethods} from "../generic-action.component";
import {User} from "../../models/user.model";
import {Client} from "../../models/client.model";
import {Subscription} from "rxjs";
import {CommonUtils} from "../../utils/common";
import {FormBuilder, Validators} from "@angular/forms";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController, ToastController} from "@ionic/angular";
import {TranslateService} from "@ngx-translate/core";
import {VetClinicService} from "../../providers/vet-clinic.service";
import {Router} from "@angular/router";
import {ClientsService} from "../../providers/clients.service";
import {ItemFinderComponent} from "../item-finder/item-finder.component";
import {CarePlanService} from "../../models/care-plan-service.model";
import {CarePlanServicesService} from "../../providers/care-plan-services.service";
import {VetineoVisitTypeMinutes} from "../../models/vet-doctor-vet-visit-type.model";
import {CarePlanServiceGroupType} from "../../models/care-plan-service-group-type.model";

@Component({
  selector: 'app-edit-care-plan-service',
  templateUrl: './edit-care-plan-service.component.html',
  styleUrls: ['./edit-care-plan-service.component.scss'],
})
export class EditCarePlanServiceComponent extends GenericActionComponent implements OnInit, OnDestroy, GenericActionComponentsMethods {

  @Input() carePlanService: CarePlanService;
  clientCarePlanServiceGroupTypes: CarePlanServiceGroupType[];
  @Input() csrfToken: string;

  @Output() objectEditedEmitter = new EventEmitter<CarePlanService>();
  @Output() objectAddedEmitter = new EventEmitter<CarePlanService>();
  @Output() hasUnsavedChangesEmitter = new EventEmitter<boolean>();

  hasUnsavedChanges: boolean = false;
  isAdmin: boolean;
  isGeneralAdmin: boolean;

  isBusy: boolean;
  dataLoaded: boolean = false;

  private isClientAdmin: boolean;
  private isGeneralWellnessPlanAdmin: boolean;
  clientSelected: Client;
  private subscriptions: Subscription = new Subscription();
  minutesToSelect: any;
  serviceTypesForClient: any[];


  constructor(
    public commonUtils: CommonUtils,
    private formBuilder: FormBuilder,
    private appStateService: AppStateService,
    private toastController: ToastController,
    private modalController: ModalController,
    private translateService: TranslateService,
    private vetClinicService: VetClinicService,
    private router: Router,
    private carePlanServicesService: CarePlanServicesService,
    private clientsService: ClientsService
  ) {
    super(commonUtils, appStateService, modalController, translateService);
  }

  ngOnInit() {
    this.isBusySub = this.appStateService.isBusySubject.subscribe(isBusy => {
      this.isBusy = isBusy;
    });

    this.minutesToSelect = Object.values(VetineoVisitTypeMinutes)?.filter(value => typeof value === "number") as number[];

    console.log(this.user);



    this.isAdmin = this.user.roles.split(';').filter(e => e === 'admin').length === 1;
    this.isGeneralWellnessPlanAdmin = this.user.vClientId === null && this.user.vetcodeId === null && this.user.roles.split(';').filter(e => e === 'wellness-plan').length === 1;
    this.isGeneralAdmin = this.isAdmin && this.user.vClientId === null && this.user.vetcodeId === null;
    this.isClientAdmin = this.isAdmin && this.user.vClientId !== null && this.user.vetcodeId === null;

    this.appStateService.updateIsBusySubject(true);

    if (this.action === 'ADD') {
      this.componentTitle = 'Dodaj nową usługę';
      this.actionBtnLabel = 'Dodaj nową usługę';
      this.actionQuestion = 'Na pewno chcesz dodać nową usługę?';
      this.actionSuccess = 'Nowa usługa została dodana';
      this.actionError = 'Wystąpił błąd podczas dodawania nowej usługi'
      this.formGroup = this.formBuilder.group({
        name: ['', [Validators.required]],
        description: ['']
      });

      if (this.user.vClientUUID) {
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.clientsService.getClientByUUID(this.user.vClientUUID).subscribe(client => {
          if (client) {
            this.clientSelected = client;
            this.registerSubscription(this.carePlanServicesService.getCarePlanServiceGroupTypes(this.clientSelected.uuid).subscribe(carePlanServiceGroupTypes => {
              if (carePlanServiceGroupTypes) {
                this.appStateService.updateIsBusySubject(false);
                this.clientCarePlanServiceGroupTypes = carePlanServiceGroupTypes;
              }
              this.appStateService.updateIsBusySubject(false);
            }, error => {
              this.appStateService.updateIsBusySubject(false);
            }));


          }
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));
      }

    } else {
      console.log(this.carePlanService);
      if (this.carePlanService.vClientId) {
        this.appStateService.updateIsBusySubject(true);
        this.registerSubscription(this.clientsService.getClientById('' + this.carePlanService.vClientId).subscribe(client => {
          if (client) {
            this.clientSelected = client;
            this.registerSubscription(this.carePlanServicesService.getCarePlanServiceGroupTypes(this.clientSelected.uuid).subscribe(carePlanServiceGroupTypes => {
              if (carePlanServiceGroupTypes) {
                this.clientCarePlanServiceGroupTypes = carePlanServiceGroupTypes;
              }
              this.appStateService.updateIsBusySubject(false);
            }, error => {
              this.appStateService.updateIsBusySubject(false);
            }));

          }
          this.appStateService.updateIsBusySubject(false);
        }, error => {
          this.appStateService.updateIsBusySubject(false);
        }));

      }

      this.componentTitle = 'Zmień usługę';
      this.actionBtnLabel = 'Zmień usługę';
      this.actionQuestion = 'Na pewno chcesz zmienić usługę?';
      this.actionSuccess = 'Usługa została zmieniona';
      this.actionError = 'Wystąpił błąd podczas zmiany usługi';
      this.formGroup = this.formBuilder.group({
        name: [this.carePlanService.name, [Validators.required]],
        description: [this.carePlanService.description]
      });

    }

    super.ngOnInit();
  }


  onCancelEdit() {
    if (this.hasUnsavedChanges) {
      this.commonUtils.presentYesNoActionSheet('Masz niezapisane zmiany, czy na pewno chcesz zrezygnować?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        this.hasUnsavedChanges = false;
        this.actionCanceledEmitter.emit(true);
      }, () => {
      });
    } else {
      this.commonUtils.presentYesNoActionSheet('Czy na pewno chcesz zrezygnować?', 'Tak', 'Nie', 'checkmark-outline', 'close', () => {
        this.actionCanceledEmitter.emit(true);
        this.hasUnsavedChanges = false;
      }, () => {
      });
    }
  }

  goTo(page: string) {
    this.router.navigateByUrl(page);
  }


  markUnsavedChanges() {
    if (!this.hasUnsavedChanges) {
      this.hasUnsavedChangesEmitter.emit(true);
    }
    super.markUnsavedChanges();
  }

  onAction() {
    if (this.formGroup.valid) {
      this.commonUtils.presentYesNoActionSheet('Na pewno chcesz zapisać zmiany?', 'Tak', 'Nie', 'checkmark', 'close', () => {
        let cps: CarePlanService = this.commonUtils.formGroupValuesToObject<CarePlanService>(new CarePlanService(), this.formGroup);

        let serviceMethod;

        this.carePlanService.name = cps.name;
        //this.carePlanService.time = cps.time;
        this.carePlanService.description = cps.description;
        if (this.clientSelected) {
          console.log(this.clientSelected)
          this.carePlanService.vClientId = this.clientSelected.id;
        } else {
          this.carePlanService.vClientId = Number.parseInt(this.user.vClientId);
        }

        if (this.action === 'EDIT') {
          serviceMethod = this.carePlanServicesService.updateCarePlanService(this.carePlanService);
        } else {
          serviceMethod = this.carePlanServicesService.addCarePlanService(this.carePlanService);
        }

        this.handleActionMethod(serviceMethod, this.objectAddedEmitter, this.objectEditedEmitter);

      }, () => {
      });
    } else {
      this.commonUtils.presentAlertToast('Popraw błędy w formularzu');
    }
  }


  async onSearchClients() {
    const modal = await this.modalController.create({
      component: ItemFinderComponent,
      componentProps: {
        title: 'Wyszukaj klienta',
        itemType: 'clients',
        nameToFind: this.clientSelected ? this.clientSelected.name : ''
      }
    });

    modal.onWillDismiss().then(data => {
      if (data && data.data) {
        this.clientSelected = data.data;

      }
    });

    return await modal.present();
  }


  registerSubscription(sub: Subscription) {
    if (sub) {
      this.subscriptions.add(sub);
    }
  }

}
